module.exports = __webpack_public_path__ + "static/media/riskpic1@2x.c086376a.png";